import { render, staticRenderFns } from "./TrendChart.vue?vue&type=template&id=2ad982fe&scoped=true&"
import script from "./TrendChart.vue?vue&type=script&lang=ts&"
export * from "./TrendChart.vue?vue&type=script&lang=ts&"
import style0 from "./TrendChart.vue?vue&type=style&index=0&id=2ad982fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad982fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VFlex,VRow})
